'use strict';

var ajax = require('./ajax'),
    util = require('./util'),
    progress = require('./progress'),
    imagesLoaded = require('imagesloaded'),
    BornModal = require('./modules/module.modal').default;

var dialog = {
    /**
     * @function
     * @description Opens a dialog using the given url (params.url) or html (params.html)
     * @param {Object} params
     * @param {Object} params.url should contain the url
     * @param {String} params.html contains the html of the dialog content
     */
    open: function (params) {
        this.replace(params);
    },
    /**
     * @description populate the dialog with html content, then open it
     **/
    openWithContent: function (params) {
        var content = params.content || params.html,
            callback;

        if (!content) {
            return;
        }

        params.options = params.options || {};
        params.options.modalContent = content;

        params.options.afterOpenCallback = function (overlay) {
            callback = (typeof params.callback === 'function') ? params.callback : function () { };
            callback();
        };

        params.options.afterCreateCallback = function (overlay) {
            callback = (typeof params.afterCreateCallback === 'function') ? params.afterCreateCallback : function () { };
            callback();
        }; 

        params.options.afterCloseCallback = function (overlay) {
            callback = (typeof params.afterCloseCallback === 'function') ? params.afterCloseCallback : function () { };
            callback();
        };

        var modal = new BornModal(params.options);
    },
    /**
     * @description Replace the content of current dialog
     * @param {object} params
     * @param {string} params.url - If the url property is provided, an ajax call is performed to get the content to replace
     * @param {string} params.html - If no url property is provided, use html provided to replace
     */
    replace: function (params) {

        if (params.url) {
            progress.show();
            params.url = util.appendParamToURL(params.url, 'format', 'ajax');
            ajax.load({
                url: params.url,
                data: params.data,
                callback: function (response) {
                    progress.hide();

                    params.content = response;
                    this.openWithContent(params);
                }.bind(this)
            });
        }

        else if (params.html) {
            this.openWithContent(params);
        }
    },
    /**
     * @function
     * @description Closes the dialog
     */
    close: function () {
        BornModal.closeModal();
    },
};

module.exports = dialog;



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/dialog.js